import { render, staticRenderFns } from "./customer-address.vue?vue&type=template&id=14871be4&"
import script from "./customer-address.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-address.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports